import store from '@/store';
var _document = document,
    body = _document.body;
var WIDTH = 992; // refer to Bootstrap's responsive design

export default {
  watch: {
    $route: function $route(route) {
      if (this.device === 'mobile' && !this.asideCollapse) {
        this.handleToggleAside();
      }
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var isMobile = this.$_isMobile();

    if (isMobile) {
      store.commit('d2admin/menu/TOGGLE_DEVICE', 'mobile');
    }
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile: function $_isMobile() {
      var rect = body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    $_resizeHandler: function $_resizeHandler() {
      if (!document.hidden) {
        var isMobile = this.$_isMobile();
        store.commit('d2admin/menu/TOGGLE_DEVICE', isMobile ? 'mobile' : 'desktop');

        if (isMobile) {// store.dispatch('app/closeSideBar', {
          //   withoutAnimation: true
          // })
        }
      }
    }
  }
};